import React from 'react';
import { SqlAuditTable } from 'src/routes/Settings/AIAssistant/components/SqlAuditTable';

export const SqlAuditTab: React.FC = () => {
  return <SqlAuditTable />;
};
